import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Menu, Dropdown, Row, Col, Icon, Badge } from 'antd'
import { Link } from 'react-router-dom'
import { api, app, config } from '../app'
import Iconz from './Iconz'
import Search from './Search'
import '../css/head.css'
import logo_img from '../assets/LOGO_1.png'
// import { observer, inject } from 'mobx-react'


function Shopping(props) {
    const hasmallrole = props.hasmallrole
    if (!hasmallrole || hasmallrole === "false") {
        return (
            <Col style={{ height: "100%" }} span={3}>
                <span className="h_r_item h_r_a" href="javaScript:void(0);" onClick={() => {
                    app.alert("您还未开通商城")
                }}>商城</span>
            </Col>
        )
    } else {
        return (
            <Col style={{ height: "100%" }} span={3}>
                <Link className="h_r_item h_r_a" to="/"  onClick={() => { config.mall_isDo2=true }}>商城</Link>
            </Col>
        )
    }
}

function toGR(history, tToken) {
    let indexno = app.getData('indexno'), team_id = app.getData('team_id')
    app.removeData('link_teamno')
    app.removeData('link_province')
    history.push(`/player/${team_id}/${indexno}?token=${tToken}`)
}

function MenuList({ dataInfo, token, rights, vname, hasmallrole, history, tToken }) {
    let { home_audit_count, user_centre_info_count, train_message_info_count } = dataInfo,
        is_admin = app.getData('is_admin'),
        user_name = (
            <div className="h_r_item h_r_l"><Badge style={{ color: '#fff' }} count={user_centre_info_count ? 1 : 0} dot><i className="iconfont icon-user_icon"></i>{vname}</Badge></div>),
        user_sign = (<Menu.Item><Link to="/sign/report" className="r_m_icon"><Iconz type="icon-punch_the_clock"
            size={18} />用户签到</Link></Menu.Item>),
        user_tongzhi = (<Menu.Item><Link to="/notice" className="r_m_icon"><Iconz type="icon-notice" size={18} />
            <Badge count={train_message_info_count ? 1 : 0} dot>通知</Badge></Link></Menu.Item>),
        user_fankui = (<Menu.Item><Link to="/feedback/my" className="r_m_icon"><Iconz type="icon-feedback" size={18} />反馈</Link></Menu.Item>),
        user_kgxt = '',//(<Menu.Item><Link to="#" className="r_m_icon"><Iconz type="icon-library" size={18}/>库管系统</Link></Menu.Item>),
        user_baoan = '',//(<Menu.Item><Link to="#" className="r_m_icon"><Iconz type="icon-report_a_case" size={18}/>报案</Link></Menu.Item>),
        user_renwu = '',//(<Menu.Item><Link to="/task" className="r_m_icon"><Iconz type="icon-mission" size={18}/>任务/报备</Link></Menu.Item>),
        user_mall_edit = is_admin === '1' ? (
            <Menu.Item><Link to="/mall-manage" className="r_m_icon"><Iconz type="icon-mission"
                size={18} />商品管理</Link></Menu.Item>) : null,
        user_orders = (<Menu.Item><Link to="/mall/orders" className="r_m_icon"><Icon type="tags"
            style={{ fontSize: 18 }} />我的订单</Link></Menu.Item>),
        user_manual = (<Menu.Item><Link to="/manual-manage" className="r_m_icon"><Icon type="book"
            style={{ fontSize: 18 }} />使用手册</Link></Menu.Item>),
        // user_expert = (<Menu.Item><Link to="/expert-manage" className="r_m_icon"><Iconz type="icon-expert" size={18} />专家库管理</Link></Menu.Item>),
        // user_donation = (<Link className="h_r_item h_r_a" to="/donation">捐赠公示</Link>),
        user_grym = (<Menu.Item><span onClick={() => {
            toGR(history, tToken)
        }} className="r_m_icon"><Iconz type="icon-user_icon" size={18} />个人页面</span></Menu.Item>),
        // user_bbrw = (<Menu.Item><span onClick={() => {
        //     history.push('/report')
        // }} className="r_m_icon"><Iconz type="icon-baobei" size={18}/>任务报备</span></Menu.Item>),
        // user_insure = (<Menu.Item><span onClick={() => {
        //     history.push('/insure')
        // }} className="r_m_icon"><Iconz type="icon-beibaoxianren" size={18} />我的保险</span></Menu.Item>),
        // user_insure = null,
        user_tcdl = (<Menu.Item><span onClick={() => {
            app.clearInfo(history)
        }} className="r_m_icon"><Iconz type="icon-Sign_out" size={18} />退出登录</span></Menu.Item>)
    if (token) {
        let information_audit = app.getData('information_audit'),
            user_review = (span) => {
                if (information_audit === '1') {
                    return (
                        <Col style={{ height: "100%" }} span={span}><Link className="h_r_item h_r_a" to="/review"><Badge
                            count={home_audit_count ? 1 : 0} dot>信息审核</Badge></Link></Col>)
                }
            }
        if (rights === 1) {  //超级管理员
            return (
                <Row style={{ display: 'flex', justifyContent: 'space-between', height: "100%" }}>
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/index">首页</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/expert">教练专家库</Link>*/}
                    {/*</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/grade">系统管理</Link>
                    </Col>
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/ranks">队伍管理</Link>
                    </Col>
                    {user_review(2, true)}
                    {/*<Col style={{ height: "100%" }} span={2}>{user_donation}</Col>*/}
                    {/* <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/find">寻人启事(超)</Link>
                    </Col> */}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/bigdata">存心大数据</Link>*/}
                    {/*</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/mall"  onClick={() => { config.mall_isDo2=true }}>商城</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/Inspection">互联网+督查</Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/skillTrain"><Badge count='New'><div style={{ margin: '15px' }}>技能培训</div></Badge></Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/player/user-report"><Badge count='New'><div style={{ margin: '15px' }}>打印服务时长</div></Badge></Link>*/}
                    {/*</Col>*/}
                    <Col className="h_user" span={2}>
                        <Dropdown trigger={['hover', 'click']} overlay={
                            <Menu>
                                {
                                    is_admin === '1' ? [
                                        (<Menu.Item key="admin_1">
                                            <span onClick={() => history.push('/super-updatePlayer')} className="r_m_icon"><Icon type="edit" size={18} />超管纠正</span>
                                        </Menu.Item>)
                                    ] : null
                                }
                                <Menu.Divider />
                                {/*{user_insure}*/}
                                {/*<Menu.Divider />*/}
                                {/*{user_mall_edit}*/}
                                {/*<Menu.Divider />*/}
                                {/*{user_tongzhi}*/}
                                {/*<Menu.Divider />*/}
                                {/*{user_expert}*/}
                                {/*<Menu.Divider/>*/}
                                {/*{user_kgxt}*/}
                                {/*{user_kgxt}*/}
                                {user_sign}
                                {/*<Menu.Divider/>*/}
                                {/*{user_renwu}*/}
                                <Menu.Divider />
                                {/*{user_baoan}*/}
                                {/*<Menu.Divider/>*/}
                                {user_orders}
                                <Menu.Divider />
                                {user_grym}
                                <Menu.Divider />
                                {user_manual}
                                <Menu.Divider />
                                {user_tcdl}
                            </Menu>
                        }>{user_name}</Dropdown></Col>
                </Row>
            )
        }
        else if (rights === 2) {   //省级管理员
            return (
                <Row style={{ display: 'flex', justifyContent: 'space-between', height: "100%" }}>
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/index">首页</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/expert">教练专家库</Link>*/}
                    {/*</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/ranks">队伍管理</Link>
                    </Col>
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/grade">系统管理</Link>
                    </Col>
                    {user_review(2, true)}
                    {/*<Col style={{ height: "100%" }} span={2}>{user_donation}</Col>*/}
                    {/* <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/find">寻人启事(省)</Link>
                    </Col> */}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/bigdata">存心大数据</Link>*/}
                    {/*</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/mall"  onClick={() => { config.mall_isDo2=true }}>商城</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/Inspection">互联网+督查</Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/skillTrain"><Badge count='New'><div style={{ margin: '15px' }}>技能培训</div></Badge></Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/player/user-report"><Badge count='New'><div style={{ margin: '15px' }}>打印服务时长</div></Badge></Link>*/}
                    {/*</Col>*/}
                    <Col className="h_user" span={2}>
                        <Dropdown trigger={['hover', 'click']} overlay={
                            <Menu>
                                {/*{user_insure}*/}
                                {/*<Menu.Divider />*/}
                                {user_fankui}
                                {/*<Menu.Divider />*/}
                                {/*{user_tongzhi}*/}
                                {/*<Menu.Divider/>*/}
                                {/*{user_kgxt}*/}
                                <Menu.Divider />
                                {user_sign}
                                <Menu.Divider />
                                {/*{user_renwu}*/}
                                {/*<Menu.Divider/>*/}
                                {/*{user_baoan}*/}
                                {/*<Menu.Divider/>*/}
                                {user_orders}
                                <Menu.Divider />
                                {user_grym}
                                <Menu.Divider />
                                {user_tcdl}
                            </Menu>
                        }>{user_name}</Dropdown></Col>
                </Row>
            )
        }
        else if (rights === 3) {   //队伍、部门管理员
            return (
                <Row style={{ display: 'flex', justifyContent: 'space-between', height: "100%" }}>
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/index">首页</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/expert">教练专家库</Link>*/}
                    {/*</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/ranks">队伍管理</Link>
                    </Col>
                    {user_review(2, true)}
                    {/* <Col style={{ height: "100%" }} span={3}>
                        <Link className="h_r_item h_r_a" to="/find">寻人启事(队)</Link>
                    </Col> */}
                    {/*<Col style={{ height: "100%" }} span={2}>{user_donation}</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/mall" onClick={() => { config.mall_isDo2=true }} >商城</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/bigdata">存心大数据</Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/Inspection">互联网+督查</Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/skillTrain"><Badge count='New'><div style={{ margin: '15px' }}>技能培训</div></Badge></Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/player/user-report"><Badge count='New'><div style={{ margin: '15px' }}>打印服务时长</div></Badge></Link>*/}
                    {/*</Col>*/}
                    {/*<Shopping hasmallrole={hasmallrole}/>*/}
                    <Col className="h_user" span={2}>
                        <Dropdown trigger={['hover', 'click']} overlay={
                            <Menu>
                                {/*{user_insure}*/}
                                {/*<Menu.Divider />*/}
                                {/*{user_tongzhi}*/}
                                {/*<Menu.Divider />*/}
                                {user_fankui}
                                <Menu.Divider />
                                {/*{user_kgxt}*/}
                                {/*<Menu.Divider/>*/}
                                {/*{user_renwu}*/}
                                {/*<Menu.Divider/>*/}
                                {user_sign}
                                <Menu.Divider />
                                {user_orders}
                                <Menu.Divider />
                                {user_grym}
                                <Menu.Divider />
                                {user_tcdl}
                            </Menu>
                        }>{user_name}</Dropdown></Col>
                </Row>
            )
        } else if (rights === 4) {   //个人登录
            return (
                <Row style={{ display: 'flex', justifyContent: 'space-between', height: "100%" }}>
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/index">首页</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={3}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/expert">教练专家库</Link>*/}
                    {/*</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/ranks">队伍信息</Link>
                    </Col>
                    {/* <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/find">寻人启事(个)</Link>
                    </Col> */}
                    {user_review(2)}
                    {/*<Col style={{ height: "100%" }} span={2}>{user_donation}</Col>*/}
                    <Col style={{ height: "100%" }} span={2}>
                        <Link className="h_r_item h_r_a" to="/mall"  onClick={() => { config.mall_isDo2=true }}>商城</Link>
                    </Col>
                    {/*<Col style={{ height: "100%" }} span={3}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/bigdata">存心大数据</Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/Inspection">互联网+督查</Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={2}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/skillTrain"><Badge count='New'><div style={{ margin: '15px' }}>技能培训</div></Badge></Link>*/}
                    {/*</Col>*/}
                    {/*<Col style={{ height: "100%" }} span={3}>*/}
                    {/*    <Link className="h_r_item h_r_a" to="/player/user-report"><Badge count='New'><div style={{ margin: '15px' }}>打印服务时长</div></Badge></Link>*/}
                    {/*</Col>*/}
                    {/*<Shopping hasmallrole={hasmallrole}/>*/}
                    <Col className="h_user" span={3}>
                        <Dropdown trigger={['hover', 'click']} overlay={
                            <Menu>
                                {/*{user_insure}*/}
                                {/*<Menu.Divider />*/}
                                {/*{user_tongzhi}*/}
                                {/*<Menu.Divider />*/}
                                {user_fankui}
                                <Menu.Divider />
                                {/*{user_renwu}*/}
                                {/*<Menu.Divider/>*/}
                                {user_sign}
                                <Menu.Divider />
                                {user_orders}
                                <Menu.Divider />
                                {user_grym}
                                <Menu.Divider />
                                {user_tcdl}
                            </Menu>
                        }>{user_name}</Dropdown></Col>
                </Row>
            )
        }
    }
    //未登录c
    return (
        <Row style={{ display: 'flex', justifyContent: 'space-between', height: "100%" }}>
            <Col style={{ height: "100%" }} span={2}>
                <Link className="h_r_item h_r_a" to="/index">首页</Link>
            </Col>
            {/*<Col style={{ height: "100%" }} span={3}>*/}
            {/*    <Link className="h_r_item h_r_a" to="/expert">教练专家库</Link>*/}
            {/*</Col>*/}
            <Col style={{ height: "100%" }} span={2}>
                <Link className="h_r_item h_r_a" to="/ranks">队伍信息</Link>
            </Col>
            {/* <Col style={{ height: "100%" }} span={3}>
                <Link className="h_r_item h_r_a" to="/find">寻人启事(未)</Link>
            </Col> */}
            <Col style={{ height: "100%" }} span={2}>
                <Link className="h_r_item h_r_a" to="/mall"  onClick={() => { config.mall_isDo2=true }}>商城</Link>
            </Col>
            {/*<Col style={{ height: "100%" }} span={2}>{user_donation}</Col>*/}
            {/*<Col style={{ height: "100%" }} span={3}>*/}
            {/*    <Link className="h_r_item h_r_a" to="/bigdata">存心大数据</Link>*/}
            {/*</Col>*/}
            {/*<Col style={{ height: "100%" }} span={2}>*/}
            {/*    <Link className="h_r_item h_r_a" to="/Inspection">互联网+督查</Link>*/}
            {/*</Col>*/}
            {/*<Col style={{ height: "100%" }} span={2}>*/}
            {/*    <Link className="h_r_item h_r_a" to="/skillTrain"><Badge count='New'><div style={{ margin: '15px' }}>技能培训</div></Badge></Link>*/}
            {/*</Col>*/}
            {/*<Col style={{ height: "100%" }} span={3}>*/}
            {/*    <Link className="h_r_item h_r_a" to="/login"><Badge count='New'><div style={{ margin: '15px' }}>打印服务时长</div></Badge></Link>*/}
            {/*</Col>*/}
            <Col style={{ height: "100%" }} span={2}>
                <Link className="h_r_item h_r_a" to="/login">登录</Link>
            </Col>
        </Row>
    )
}


// @inject('task')
// @observer
class Head extends Component {
    //
    constructor(props) {
        super(props)
        this.state = {
            tToken: '',
            vname: app.getData("vname"),
            token: app.getToken(),
            rights: app.getData("rights"),
            hasmallrole: app.getData("hasmallrole"),
            dataInfo: {},
        }
    }

    setData(data, cb) {
        app.setState(this, data, cb)
    }

    async componentDidMount() {
        this._isMounted = true
        this.getTokeni();
        let { token } = this.state
        // if (token) {
        //     await this.handleData()
        // }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    handleData = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.HomeAuditCount, params)
        if (flag === 1) {
            app.setData('user_train_info_count', data.user_train_info_count)
            app.setData('user_message_info_count', data.user_message_info_count)
            app.setData('information_audit', data.information_audit + '')
            this.setData({ dataInfo: data })
        } else {
            console.error(msg)
        }
    }

    /**
    * 获取token
    * @returns {Promise<void>}
    */
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                tToken: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    componentWillReceiveProps(props) {
        this.setData({
            vname: app.getData("vname"),
            token: app.getToken(),
            rights: app.getData("rights"),
            hasmallrole: app.getData("hasmallrole")
        })
    }

    render() {
        let { background, notLogin, notLogo, height, history, center } = this.props
        let { vname, token, rights, hasmallrole, dataInfo, tToken } = this.state

        if (center) {
            return (
                <div className="head" style={{
                    background: (background ? background : "transparent"),
                    height: (height ? height : 104),
                    textAlign: 'center'
                }}>
                    <Row type="flex" justify="space-around" align="middle" style={{ padding: '3rem 0' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="h_l_img">
                                <img style={{ display: 'block' }} src={logo_img} alt="" />
                            </div>
                            <span className="h_l_title">存心救援信息公开平台</span>
                        </div>
                        <Search history={history} />
                    </Row>
                    <Row type="flex" align="middle" style={{ background: 'rgba(0,0,0,.2)', height: 60 }}>
                        <div style={{ width: '100%', height: '100%' }}>
                            <MenuList token={token} rights={rights} vname={vname} hasmallrole={hasmallrole}
                                history={history} dataInfo={dataInfo} tToken={tToken} />
                        </div>
                    </Row>
                </div>
            )
        } else {
            return (
                <div className="head"
                    style={{ background: (background ? background : "transparent"), height: (height ? height : 104) }}>
                    <Row justify="center" style={{ height: "100%" }}>
                        <Col span={4} style={{ height: "100%" }}>
                            {
                                notLogo ? (notLogo === true ? '' : notLogin) : (
                                    <div className="head_left">
                                        <div className="h_l_img">
                                            <img src={logo_img} alt="" />
                                        </div>
                                        <span className="h_l_title">存心救援信息公开平台</span>
                                    </div>
                                )
                            }
                        </Col>
                        <Col span={20} style={{ height: "100%" }} className="head_right">
                            <MenuList token={token} rights={rights} vname={vname} hasmallrole={hasmallrole}
                                history={history} dataInfo={dataInfo} tToken={tToken} />
                        </Col>
                    </Row>
                </div>
            )
        }
    }

}

Head.propTypes = {
    // notLogin: PropTypes.bool, //不需要logo
    background: PropTypes.string, //背景色
    height: PropTypes.any, //高度
    history: PropTypes.object.isRequired
}

export default Head




// WEBPACK FOOTER //
// ./src/components/Head.jsx